import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { MessageBoxDialogOptions } from "./messagebox-dialog";
import { MessageBoxDialogComponent } from "./messagebox-dialog.component";


@Injectable()
export class MessageBoxDialogService {

    constructor(private matDialog: MatDialog) {}

    // #region Close All Dialogs Service Call

    CloseAllDialogs(): void {
        this.matDialog.closeAll();
    }

    // #endregion

    // #region Open Message Box Dialog Service Call

    Open(options?: MessageBoxDialogOptions): Observable<boolean> {
        const self = this;

        const openHandle = self.matDialog.open<MessageBoxDialogComponent>(MessageBoxDialogComponent, {
            disableClose: true,
            data: {
                TitleText: 'Information',
                MessageText: '',
                OKText: 'OK',
                ...options,
            },
            // width: self.smallMediaSize ? '80vw' : options?.width || '600px',
            // height: self.smallMediaSize ? '80vh' : options?.height || '400px',
            width: '600px',
            height: '400px',
            maxHeight: '85vh',
        });

        return openHandle.afterClosed();
    }

    // #endregion
}